import {
    GET_FONTS_LIST,
    GET_FONTS_LIST_IN_CALENDAR_SUCCESS,
    GET_FONTS_LIST_IN_QUIZ_SUCCESS,
    STORE_FONT,
    STORE_FONT_IN_CALENDAR_SUCCESS,
    STORE_FONT_IN_QUIZ_SUCCESS
} from './constants.js';

/**
 *
 * @param widget
 * @returns {{widget: *, type: string}}
 */
const getFontsList = ( widget ) => ( {
    type: GET_FONTS_LIST,
    widget
} );
/**
 *
 * @param fonts
 * @param widget
 * @returns {{fonts: *, type: string}}
 */
const getFontsListSuccess = ( fonts, widget ) => ( {
    type: widget === 'quiz' ? GET_FONTS_LIST_IN_QUIZ_SUCCESS : GET_FONTS_LIST_IN_CALENDAR_SUCCESS,
    fonts
} );
/**
 *
 * @param widget
 * @param font
 * @returns {{widget: *, type: string, font: *}}
 */
const storeFont = ( widget, font ) => ( {
    type: STORE_FONT,
    widget,
    font
} );
/**
 *
 * @param fonts
 * @param widget
 * @returns {{fonts: *, type: string}}
 */
const storeFontSuccess = ( fonts, widget ) => ( {
    type: widget === 'quiz' ? STORE_FONT_IN_QUIZ_SUCCESS : STORE_FONT_IN_CALENDAR_SUCCESS,
    fonts
} );


export {
    storeFont,
    storeFontSuccess,
    getFontsList,
    getFontsListSuccess
};